import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  FaUserCircle,
  FaSignOutAlt,
  FaSearch,
  FaBell,
  FaCog,
  FaBars,
  FaSun,
  FaMoon,
} from "react-icons/fa";

export default function Navbar({ onToggleSidebar }) {
  const [openMenu, setOpenMenu] = useState(false);
  const [userName, setUserName] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("admin_theme") === "dark" ||
    (!localStorage.getItem("admin_theme") && window.matchMedia("(prefers-color-scheme: dark)").matches)
  );

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("admin_theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("admin_theme", "light");
    }
  }, [isDarkMode]);

  const navigate = useNavigate();

  // =====================================================
  // GREETING
  // =====================================================

  const hour = new Date().getHours();

  const greeting =
    hour >= 5 && hour < 12
      ? "Good Morning"
      : hour >= 12 && hour < 17
      ? "Good Afternoon"
      : hour >= 17 && hour < 21
      ? "Good Evening"
      : "Good Night";

  // =====================================================
  // USER DATA
  // =====================================================

  useEffect(() => {
    const adminData = JSON.parse(localStorage.getItem("ADMIN"));

    if (adminData?.name) {
      setUserName(adminData.name);
    }
  }, []);

  // =====================================================
  // LOGOUT
  // =====================================================

  const handleLogout = () => {
    localStorage.removeItem("ADMIN");
    navigate("/");
  };

  return (
    <>
      {/* ===================================================== */}
      {/* NAVBAR */}
      {/* ===================================================== */}

      <div
        className="
          fixed
          top-0
          right-0
          z-40
          md:left-72
          left-0
          h-20
          bg-white/80
          backdrop-blur-md
          border-b
          border-slate-200/40
          shadow-sm
        "
      >
        <div
          className="
            h-full
            px-4
            md:px-8
            flex
            items-center
            justify-between
          "
        >
          {/* ===================================================== */}
          {/* LEFT (with responsive sidebar toggle) */}
          {/* ===================================================== */}

          <div className="flex items-center gap-3">
            <button
              onClick={onToggleSidebar}
              className="md:hidden p-2 text-slate-500 hover:text-slate-800 hover:bg-slate-100/60 rounded-xl transition-all"
            >
              <FaBars size={18} />
            </button>

            <div>
              <h2 className="text-sm md:text-lg font-semibold text-slate-800 dark:text-slate-200 leading-tight">
                {greeting},{" "}
                <span className="font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-indigo-800 dark:from-indigo-400 dark:to-violet-400">
                  {userName || "Admin"}
                </span>
              </h2>

              <p className="text-[10px] md:text-xs text-slate-500 mt-0.5 hidden sm:block">
                Welcome to your HRMS analytics dashboard
              </p>
            </div>
          </div>

          {/* ===================================================== */}
          {/* RIGHT */}
          {/* ===================================================== */}

          <div className="flex items-center gap-4">

            {/* Search */}

            {/* <div
              className="
                hidden
                md:flex
                items-center
                gap-3
                bg-[#f5f5f5]
                border
                border-gray-200
                rounded-2xl
                px-4
                h-11
                w-72
              "
            >
              <FaSearch className="text-gray-400 text-sm" />

              <input
                type="text"
                placeholder="Search employee, report..."
                className="
                  bg-transparent
                  outline-none
                  text-sm
                  w-full
                  text-black
                  placeholder:text-gray-400
                "
              />
            </div> */}

            {/* Notifications */}

            {/* <button
              className="
                relative
                h-11
                w-11
                rounded-2xl
                border
                border-gray-200
                bg-white
                flex
                items-center
                justify-center
                hover:bg-gray-50
                transition-all
              "
            >
              <FaBell className="text-gray-700 text-sm" />

              <span
                className="
                  absolute
                  top-2
                  right-2
                  h-2
                  w-2
                  rounded-full
                  bg-black
                "
              />
            </button> */}

            {/* Settings */}

            {/* <button
              className="
                hidden
                md:flex
                h-11
                w-11
                rounded-2xl
                border
                border-gray-200
                bg-white
                items-center
                justify-center
                hover:bg-gray-50
                transition-all
              "
            >
              <FaCog className="text-gray-700 text-sm" />
            </button> */}

            {/* Theme Toggle */}
            <button
              onClick={() => setIsDarkMode(!isDarkMode)}
              className="
                h-10
                w-10
                rounded-xl
                border
                border-slate-200
                dark:border-slate-800/80
                bg-white
                dark:bg-[#1f2937]
                flex
                items-center
                justify-center
                hover:bg-slate-50
                dark:hover:bg-slate-800/60
                transition-all
                duration-200
                shadow-sm
                text-slate-600
                dark:text-slate-300
              "
              aria-label="Toggle Theme"
            >
              {isDarkMode ? <FaSun size={15} className="text-amber-500" /> : <FaMoon size={14} />}
            </button>

            {/* Profile */}

             <div className="relative">

              <button
                onClick={() => setOpenMenu(!openMenu)}
                className="
                  flex
                  items-center
                  gap-3
                  bg-white
                  dark:bg-[#1f2937]
                  border
                  border-slate-200
                  dark:border-slate-800/85
                  rounded-xl
                  px-4
                  py-1.5
                  hover:bg-slate-50
                  dark:hover:bg-slate-800
                  transition-all
                  duration-200
                  shadow-sm
                  text-slate-800
                  dark:text-slate-200
                "
              >
                <FaUserCircle className="text-xl text-indigo-500" />

                <div className="hidden md:block text-left">
                  <p className="text-xs font-semibold leading-none">
                    {userName || "Admin"}
                  </p>

                  <p className="text-[10px] text-slate-400 dark:text-slate-500 mt-1">
                    Administrator
                  </p>
                </div>
              </button>

              {/* ===================================================== */}
              {/* DROPDOWN */}
              {/* ===================================================== */}

              {openMenu && (
                <div
                  className="
                    absolute
                    right-0
                    top-14
                    w-64
                    bg-white/95
                    dark:bg-[#111827]/95
                    backdrop-blur-md
                    border
                    border-slate-250
                    dark:border-slate-800
                    rounded-2xl
                    shadow-xl
                    overflow-hidden
                    z-50
                    animate-fadeIn
                  "
                >
                  {/* User Info */}

                  <div className="p-4 border-b border-slate-100 dark:border-slate-800/60">
                    <div className="flex items-center gap-3">
                      <FaUserCircle className="text-3xl text-slate-400 dark:text-slate-500" />

                      <div>
                        <h3 className="text-xs font-bold text-slate-800 dark:text-slate-200">
                          {userName || "Admin"}
                        </h3>

                        <p className="text-[10px] text-slate-400 dark:text-slate-500 mt-0.5">
                          admin@morganhrms.com
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Menu */}

                  <div className="p-1.5">
                    <button
                      onClick={handleLogout}
                      className="
                        w-full
                        flex
                        items-center
                        gap-3
                        px-4
                        py-2.5
                        rounded-xl
                        text-xs
                        font-medium
                        text-red-650
                        hover:bg-red-50/60
                        dark:hover:bg-red-950/20
                        transition-all
                        duration-200
                      "
                    >
                      <FaSignOutAlt />

                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}